<template>
	<v-tabs
		v-model="localValue"
		show-arrows
		hide-slider
		centered
		:optional="optional"
		center-active
		active-class="secondary white--text"
	>
		<!-- :style="{ maxWidth: `${maxWidth}px`}" -->
		<v-tab
			v-for="day in selectedMonthDays"
			:key="day.date"
			class="d-flex flex-column rounded-sm px-2"
			style="min-width: 0; overflow: hidden"
			:tab-value="day.date"
			:disabled="(!day.isCurrentDay && disabled ) || new Date(day.date).getDay() === 5"
			@change="$emit('change', day.date)"
		>
			<!-- :class="{ 'grey--text': !day.isCurrentMonth }" -->
			<div class="d-flex">
				<span class="text-caption">{{day.shortName}}</span>
			</div>
			<span class="text-body-1">{{day.dayNumber}}</span>
		</v-tab>
	</v-tabs>
</template>

<script>
import moment from 'moment';
export default {
	name: 'VMonthDays',

	props: {
		month: { type: String, default: new Date().toISOString().slice(0, 7) },
		optional: { type: Boolean, default: true },
		value: { type: String, default: () => moment().format('YYYY-MM-DD') },
		maxWidth: { type: Number },
		disabled: { type: Boolean, default: false },
	},

	computed: {
		// selectedMonthDays() {
		// 	const days = [];
		// 	const currentMonth = moment(this.month, 'YYYY-MM');
		// 	const daysInMonth = currentMonth.daysInMonth();
		// 	const firstDayOfMonth = currentMonth.startOf('month').day();

		// 	const prevMonth = currentMonth.clone().subtract(1, 'month');
		// 	const daysInPrevMonth = prevMonth.daysInMonth();

		// 	for (let i = firstDayOfMonth; i > 0; i--) {
		// 		const day = daysInPrevMonth - i + 1;
		// 		const date = prevMonth.clone().date(day).format('YYYY-MM-DD');
		// 		days.push({
		// 			dayNumber: day.toString().padStart(2, '0'),
		// 			shortName: moment(date).format('dd'),
		// 			shortMonthName: moment(date).format('MMM'),
		// 			date,
		// 			isCurrentMonth: false
		// 		});
		// 	}

		// 	for (let i = 1; i <= daysInMonth; i++) {
		// 		const date = this.month + '-' + i.toString().padStart(2, '0');
		// 		days.push({
		// 			dayNumber: i.toString().padStart(2, '0'),
		// 			shortName: moment(date).format('dd'),
		// 			shortMonthName: moment(date).format('MMM'),
		// 			date,
		// 			isCurrentMonth: true
		// 		})
		// 	}

		// 	const nextMonth = currentMonth.clone().add(1, 'month');
		// 	const remainingDays = 42 - days.length;

		// 	for (let i = 1; i <= remainingDays; i++) {
		// 		const date = nextMonth.clone().date(i).format('YYYY-MM-DD');
		// 		days.push({
		// 			dayNumber: i.toString().padStart(2, '0'),
		// 			shortName: moment(date).format('dd'),
		// 			shortMonthName: moment(date).format('MMM'),
		// 			date,
		// 			isCurrentMonth: false
		// 		});
		// 	}

		// 	return days;
		// },
		selectedMonthDays() {
			const days = [];
			const baseMonth = moment(this.month, 'YYYY-MM');

			// Loop from 3 months before to 3 months after
			for (let i = -3; i <= 3; i++) {
				const targetMonth = baseMonth.clone().add(i, 'months');
				const daysInMonth = targetMonth.daysInMonth();

				// Loop through each day of the target month
				for (let day = 1; day <= daysInMonth; day++) {
					const date = targetMonth.clone().date(day).format('YYYY-MM-DD');
					days.push({
						dayNumber: day.toString().padStart(2, '0'),
						shortName: moment(date).format('dd'),
						shortMonthName: moment(date).format('MMM'),
						date,
						isCurrentMonth: i === 0,
						isCurrentDay: date === this.value
					});
				}
			}
			return days;
		},

		localValue: {
			get() {
				return this.value;
			},
			set(newVal) {
				this.$emit('input', newVal);
			}
		}
	}
}
</script>

<style>

</style>